<div class="offline-map-diagram">
  <div id="map-drop-area"
       [contextMenu]="basicMenu"
       [contextMenuSubject]="contextMenuData"
       [dndDropzone]=""
       (dndDrop)="onDrop($event)">
    <div *ngFor="let item of draggedItems.nodes">
      <img *ngIf="draggedItems.item.type !=='voippeer' && draggedItems.item.productType === item.productType"
           class="dragged map-item" [ngStyle]="{'left': offsetX, 'top': offsetY}"
           src="assets/images/network/fab/{{item.svg}}.svg">
    </div>
    <div *ngFor="let item of draggedItems.voippeers">
      <img *ngIf="draggedItems.item.type !== 'node' && draggedItems.item.deviceType === item.deviceType"
           class="dragged map-item" [ngStyle]="{'left': offsetX, 'top': offsetY}"
           src="assets/images/network/fab/{{item.svg}}.svg">
    </div>

    <context-menu>
      <ng-template *ngFor="let action of contextMenuData"
                   contextMenuItem
                   (execute)="action.click()"
                   [visible]="action.visible"
                   [enabled]="!action.disabled"
                   [subMenu]="(action.subMenu === 'lockSubMenu') ? lockSubMenu : null"
                   [divider]="action.divider">
        <span [innerHtml]="action.html"></span>
      </ng-template>

      <context-menu #lockSubMenu>
        <ng-template *ngFor="let action of peerConnectionSubMenuData"
                     contextMenuItem
                     (execute)="action.click()"
                     [visible]="action.visible"
                     [enabled]="!action.disabled"
                     [divider]="action.divider">
          <span [innerHtml]="action.html"></span>
        </ng-template>
      </context-menu>
    </context-menu>

    <network-diagram diagramId="offline-diagram"
                     #offlineDiagram
                     [initialDiagramOptions]="savedMapConfigurations"
                     (onDiagramReady)="onDiagramReady($event.diagramApi)"
                     (onSelect)="onSelect($event)"
                     (onDragStart)="onDragStart($event)"
                     (onDiagramClick)="onDiagramClick($event)"
                     (onEdgeDragged)="onEdgeDragged($event)"
                     (onContextMenu)="onContextMenu($event)"
                     [getClusteredEdgePropertiesByEdges]="getClusteredEdgePropertiesByEdges"
                     [getClusteredNodePropertiesByNodes]="getClusteredNodePropertiesByNodes">
    </network-diagram>

    <eco-fab-speed-dial *ngIf="isAuthorizedUser" [open]="addItemsMenu.isAddItemsMenuOpen" [fixed]="true">
      <eco-fab-speed-dial-trigger [spin]="true">
        <button mat-fab color="primary"
                (contextmenu)="stopPropagation($event)"
                (click)="closeAllContainersScope(); addItemsMenu.isAddItemsMenuOpen = !addItemsMenu.isAddItemsMenuOpen;">
          <mat-icon class="spin180">add</mat-icon>
        </button>
      </eco-fab-speed-dial-trigger>

      <eco-fab-speed-dial-actions>
        <button class="nodes_fab" mat-mini-fab
                (contextmenu)="stopPropagation($event)"
                (click)="addItemsMenu.addNodeContainerOpen = !addItemsMenu.addNodeContainerOpen; addItemsMenu.addVoipPeerContainerOpen = false">
          <mat-icon>transform</mat-icon>
        </button>
        <button class="voipPeers_fab" mat-mini-fab
                (contextmenu)="stopPropagation($event)"
                (click)="addItemsMenu.addVoipPeerContainerOpen = !addItemsMenu.addVoipPeerContainerOpen; addItemsMenu.addNodeContainerOpen = false">
          <mat-icon>call</mat-icon>
        </button>
      </eco-fab-speed-dial-actions>
    </eco-fab-speed-dial>


    <div class="nodes-container" [hidden]="!(addItemsMenu.isAddItemsMenuOpen && addItemsMenu.addNodeContainerOpen)">
      <div *ngFor="let node of draggedItems.nodes"
           class="map-item-container">
        <img class="map-item"
             title="drag {{node.displayName}}"
             (contextmenu)="stopPropagation($event)"
             [dndDraggable]="node"
             [dndEffectAllowed]="draggable.effectAllowed"
             src="assets/images/network/fab/{{node.svg}}.svg">
      </div>
    </div>

    <div class="voippers-container"
         [hidden]="!(addItemsMenu.isAddItemsMenuOpen && addItemsMenu.addVoipPeerContainerOpen)">
      <div *ngFor="let voippeer of draggedItems.voippeers"
           class="map-item-container">
        <img class="map-item"
             title="drag {{voippeer.displayName}}"
             (contextmenu)="stopPropagation($event)"
             [dndDraggable]="voippeer"
             [dndEffectAllowed]="draggable.effectAllowed"
             src="assets/images/network/fab/{{voippeer.svg}}.svg">
      </div>
    </div>
  </div>

  <img class="offline-map-indicator" src="assets/images/network/offline.png">

  <div class="diagram-related-actions-container">
    <div class="map-action" matTooltipPosition="before" matTooltip="Save map">
      <button mat-button class="map-action-button"
              (click)="sendItemsLocationToServer()"
              [disabled]="!isAuthorizedUser || !isSendItemsLocationToServerEnabled()">
        <mat-icon>save</mat-icon>
      </button>
    </div>

    <div class="map-action" matTooltipPosition="before" matTooltip="Map settings">
      <button mat-button class="map-action-button"
              [matMenuTriggerFor]="appMenu"
              #trigger="matMenuTrigger">
        <mat-icon>settings</mat-icon>
      </button>
    </div>

    <mat-menu #appMenu="matMenu">
      <div class="diagram-configurations-dropdown-content-container" (click)="$event.stopPropagation()">
        <form #f="ngForm">
        <div class="map-configuration-title">Map settings</div>
        <mat-checkbox [(ngModel)]="savedMapConfigurations.visjs.interaction.hideEdgesOnDrag"
                      [ngModelOptions]="{standalone: true}" color="primary">
          Hide edges on drag
        </mat-checkbox>

        <mat-checkbox [(ngModel)]="savedMapConfigurations.advancedConfigurations.drawAnimated"
                      [ngModelOptions]="{standalone: true}" color="primary">
          Animate path drawing
        </mat-checkbox>

        <mat-checkbox [(ngModel)]="savedMapConfigurations.labelOptions.shorten"
                      [ngModelOptions]="{standalone: true}" color="primary">
          Limit labels length
        </mat-checkbox>

        <div class="label-length-spinner" *ngIf="savedMapConfigurations.labelOptions.shorten">
          <mat-form-field class="sixtyPerWidth">
            <mat-label>Max label length</mat-label>
            <input matInput [(ngModel)]="savedMapConfigurations.labelOptions.length"
                   type="number" min="2" max="255" name="weight">
            <mat-error>value range between 2 to 255</mat-error>
          </mat-form-field>
        </div>

        <div class="diagram-configurations-apply-container">
          <ac-button color="primary" mat-raised-button
                  (click)="updateMapConfigurations(); trigger.closeMenu()" [ngDisabled]="!f.form.valid">
            <span>Apply</span>
          </ac-button>
        </div>
        </form>
      </div>
    </mat-menu>

    <div class="map-action" matTooltipPosition="before" matTooltip="Center map">
      <button class="map-action-button" mat-button color="primary" (click)="bringIntoView()">
        <mat-icon>filter_center_focus</mat-icon>
      </button>
    </div>

    <div class="layers">
      <div class="layers-container" [ngClass]="{'open': selectedLayersObject.isOpen}" matTooltipPosition="before" matTooltip="Layers">
        <mat-icon aria-hidden="false" (click)="selectedLayersObject.isOpen = !selectedLayersObject.isOpen; updateMapWithLayers()">more_horiz</mat-icon>
      </div>

      <div class="layers-container-icons" [@inOutAnimation] *ngIf="selectedLayersObject.isOpen">
        <mat-divider></mat-divider>
        <div class="layer-icon" matTooltipPosition="before" matTooltip="Topology"
             [ngClass]="{'selected': selectedLayersObject.topology}"
             (click)="selectedLayersObject.topology = !selectedLayersObject.topology; updateMapWithLayers()">
          <mat-icon>public</mat-icon>
        </div>
        <mat-divider></mat-divider>
        <div class="layer-icon" matTooltipPosition="before" matTooltip="Quality"
             [ngClass]="{'selected': selectedLayersObject.quality}"
             (click)="selectedLayersObject.quality = !selectedLayersObject.quality; updateMapWithLayers()">
          <mat-icon>graphic_eq</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
